import {
  DriverPick,
  DriverName,
  DriverPoints,
  DriverLogoContainer,
} from "./styles";
import { selectDriverRosterIdFromTournament } from "selectors/Tournament";
import { RosterOrgLogo } from "components/Logo/RosterOrgLogo";
import { selectTournamentDriverName } from "selectors/Roster";
import { useAppSelector } from "app/hooks";

interface Props {
  driverId: string;
  driverPoints: number | undefined;
  tournamentId: string;
}

export const PickemUserDriverPick = ({
  driverId,
  driverPoints,
  tournamentId,
}: Props) => {
  const driverName = useAppSelector((state) =>
    selectTournamentDriverName(state, driverId, tournamentId)
  );
  const rosterId = useAppSelector((state) =>
    selectDriverRosterIdFromTournament(state, tournamentId, driverId)
  );

  return (
    <DriverPick key={driverId}>
      <DriverLogoContainer>
        {!!rosterId && (
          <RosterOrgLogo rosterId={rosterId} tournamentId={tournamentId} />
        )}
      </DriverLogoContainer>
      <DriverName>{driverName}</DriverName>
      <DriverPoints>{driverPoints ?? "-"}</DriverPoints>
    </DriverPick>
  );
};
